/* -----------------Globals--------------- */
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons";

/* -----------------UI--------------- */
import { Divider, List } from "react-native-paper";

/* -----------------Helpers & Hooks--------------- */
import { useAppTheme } from "../../useAppTheme";

/* -----------------Types--------------- */
import type { IconType } from "../TextLoop";

/* -----------------Child components--------------- */
import Box from "../Box";
import { Radio } from "../Radio";

type FeedbackReasonsProps = {
	feedbackReasonList: {
		title: string;
		description: string;
		icon: IconType;
		value: string;
	}[];
	selectedReason: string | null;
	onReasonPress: (reason: string) => void;
};

export const FeedbackReasons = ({
	feedbackReasonList,
	selectedReason,
	onReasonPress,
}: FeedbackReasonsProps) => {
	const theme = useAppTheme();

	return (
		<Box paddingHorizontal={24}>
			{feedbackReasonList.map((reason, index) => (
				<Box key={reason.value}>
					<List.Item
						style={{
							paddingVertical: 8,
							paddingHorizontal: 8,
						}}
						onPress={() => onReasonPress(reason.value)}
						title={reason.title}
						description={reason.description}
						left={() => (
							<Box
								alignItems="center"
								justifyContent="center"
								width={24}
								height={24}
							>
								<MaterialCommunityIcons
									name={
										reason.icon as keyof typeof MaterialCommunityIcons.glyphMap
									}
									size={24}
									color={theme.colors.onSurface}
								/>
							</Box>
						)}
						right={() => (
							<Radio
								disabled={false}
								status={
									selectedReason === reason.value ? "checked" : "unchecked"
								}
								value={reason.value}
								onPress={() => onReasonPress(reason.value)}
							/>
						)}
					/>
					{index !== feedbackReasonList.length - 1 && <Divider />}
				</Box>
			))}
		</Box>
	);
};
